import { render, staticRenderFns } from "./FilmCards.vue?vue&type=template&id=55ea1656&scoped=true&"
import script from "./FilmCards.vue?vue&type=script&lang=js&"
export * from "./FilmCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea1656",
  null
  
)

export default component.exports